import { useState, useEffect } from 'react';

import type { Reaction, Pagination } from '../../output/models';

import { config } from '../../config';
import { ReactionsApi, GetReactionsRequest } from '../../output/apis';

const initialPagination: Pagination = {
  page: 0,
  pages: 0,
  count: 0,
  items: 100,
  from: 0,
  to: 0,
};

interface Response {
  data: Reaction[] | undefined;
  pagination: Pagination;
  loading: boolean;
}

export const useData = (page: string, date?: string, sort?: string): Response => {
  const [data, setData] = useState<Reaction[] | undefined>(undefined);
  const [pagination, setPagination] = useState<Pagination>(initialPagination);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);

    const req: GetReactionsRequest = { page };

    if (date) {
      req.date = date;
    }

    if (sort) {
      req.sort = sort;
    }

    new ReactionsApi(config)
      .getReactions(req)
      .then((res) => {
        setData(res.data);
        setPagination(res.pagination);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, date, sort]);

  return { data, pagination, loading };
};
